<template>
    <div v-if="itemDetail">
        <div class="sports_result"  ref="imageDom" v-if="!firstFlag">
            <img class="fl" crossorigin="anonymous" :src="require('@/assets/img/common/5.png')" alt="">
            <div class="header">
                <div class="avatar">
                    <van-image crossorigin="anonymous" :src="myinfo.userInfo.avatarurl"></van-image>
                </div>
                <div class="nickname">
                    {{myinfo.name||myinfo.userInfo.nickname}} 恭喜您!
                </div>
            </div>

            <div class="body">
                <div class="header">
                    <!-- {{itemDetail.myinfo.nickname || itemDetail.myinfo.name}}，恭喜您! -->
                </div>

                <div class="body">
                    <mVideo :videoUrl="myinfo.sportsItemSub.animation==1?myinfo.animationurl:myinfo.mediaurl" height="3.38rem" :mediaType="itemDetail.media_type" v-if="+itemDetail.type!==5"></mVideo>
                    <div class="set">
                        <div class="desc">
                            正在参加
                            <p style="font-weight: bold;color: rgba(251, 102, 39, 1);">{{ itemDetail.title }}</p>
                            <!-- <p v-if="+myinfo.state===1">
                                <template v-if=" +itemDetail.type!==5 && myinfo.score*1>0">
                                    系统得分:{{ myinfo.score }}
                                </template>
                            </p>
                            <p v-else-if="+itemDetail.type===4 || +itemDetail.type===5">请耐心等待管理员审核</p>
                            <p v-else-if="+myinfo.state===3 || myinfo.state*1===4">视频审核不通过</p> -->
                            <!-- <p v-else>稍后请回到该页面查看分数</p> -->
                        </div>
                        <div class="sh">
                            <img class="qrcode" crossorigin="anonymous" :src="myinfo.sportsItemSub.qrcode" alt="">
                            <!-- <div class="qrcode" ref="qrCodeUrl"></div> -->
                            <!--  -->
                            <div>
                                扫码参与
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            
            <div class="footer" v-if="itemDetail.myinfo.cert && +itemDetail.type!==5">
                <Button
                        :disabled="!itemDetail.myinfo.cert"
                        @click="certShow = true"
                        round
                        type="primary"
                        block
                        :color="buttonColor"
                >下载证书
                </Button
                >
            </div>
        </div>
        <template v-else>
            <div class="capture-img" @click="showrule = false">
                <!-- 生成后的图片 -->
                <img :src="dataURL"  alt="" >
                <div class="nt">长按图片可保存至相册</div>
            </div>
            
        </template>
        

        <Popup v-model="certShow">
            <van-image
                    :src="itemDetail.myinfo.cert"
                    fit="cover"
                    width="5rem"
                    style="display:flex;align-items: center;justify-content: center;"
            ></van-image>

            <div style="font-size:12px;text-align: center;margin:.2rem 0;">
                长按保存证书
            </div>
        </Popup>

        
    </div>
    <Empty v-else description="数据加载中"/>
</template>

<style lang="less" scoped>
    @import './index.less';
</style>

<script>
    import html2canvas from "html2canvas";
    import mVideo from '@/components/mVideo/index';
    import {mapGetters} from 'vuex';
    import VueQr from 'vue-qr'
    import {Empty, Panel, Cell, Button, CellGroup, Image, Popup} from 'vant';

    export default {
        computed: {
            buttonColor() {
                let detail = this.detail;
                if (!detail) return '#ccc';
                return `${detail.tabstyle[0]['color']}`;
            }
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            VanImage: Image,
            mVideo,
            Popup,
            VueQr
        },
        data() {
            return {
                detail: '',
                itemDetail: '',
                joinList: [],
                certShow: false,
                myinfo: {},
                item_sub_id: '',
                sports_id: '',
                firstFlag: false,
                dataURL: '',
                qrCodeUrl: '',
                v: 750 / window.innerWidth
            };
        },
        methods: {
            init: function () {
                this.$toast.loading({
                    duration: 0,
                });
                let that = this
                let params = {cpgid: this.item_sub_id};
                Promise.all([
                    this.$api.sports.sportsMain(this.sports_id),
                    this.$api.sports.compareRank(params),
                    this.$api.sports.getVoteDetail(this.$route.query.id)
                ]).then((res) => {
                    let {bgstyle, id, tabstyle, introstyle, title} = res[0].data;
                    try {
                        bgstyle = JSON.parse(bgstyle);
                        tabstyle = JSON.parse(tabstyle);
                        introstyle = JSON.parse(introstyle);
                    } catch (e) {
                        console.error(e);
                    }
                    this.detail = {id, bgstyle, tabstyle, introstyle, title};
                    this.joinList = res[1]['list'];
                    delete res[1]['data']['list'];
                    if (res[1]['data']['registerform']) {
                        try {
                            res[1]['data']['registerform'] = JSON.parse(
                                res[1]['data']['registerform']
                            );
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.itemDetail = res[1]['data'];
                    // this.qrCodeUrl = res[2]['data']['sportsItemSub']['qrcode']
                    this.myinfo = res[2]['data'];
                    setTimeout(function () {
                        that.saveimage();
                    },1000);
                    this.$toast.clear();
                });
            },
            saveimage(){
              html2canvas(this.$refs.imageDom,{useCORS: true}).then(canvas => {
                  // 转成图片，生成图片地址
                  // console.log(111)
                  this.dataURL = canvas.toDataURL("image/jpeg", 1.0);
                  this.firstFlag = true;
              });
            }
        },
        mounted() {        
            this.item_sub_id = this.$route.params.item_sub_id
            this.sports_id = this.$route.params.sports_id
            this.init();
            // this.creatQrCode()
        },
    };
</script>
